import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "เลือกช่วงวันที่ที่ต้องการ export", -1)
const _hoisted_3 = { class: "flex flex-wrap gap-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "flex-shrink-0 text-gray-400" }, "→", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, "* ไม่รวมวันปัจจุบัน · เลือกได้สูงสุด 31 วัน", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_11 = { class: "flex justify-end gap-2 pt-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "py-8 text-center space-y-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, "กำลังสร้างรายงาน กรุณารอสักครู่...", -1)
const _hoisted_15 = {
  key: 2,
  class: "py-6 text-center space-y-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-700" }, "รายงานพร้อมแล้ว", -1)
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ดาวน์โหลดรายงาน ")
const _hoisted_19 = {
  key: 3,
  class: "py-6 text-center space-y-4"
}
const _hoisted_20 = { class: "text-sm text-red-600" }

import { ref, watch, inject } from "vue";
import dayjs from "dayjs";
type DayjsT = ReturnType<typeof dayjs>;
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import DialogComponent from "@/components/doalog/DialogComponent.vue";

interface Preset { key: string; label: string; build: () => { start: DayjsT; end: DayjsT } }

export default /*#__PURE__*/_defineComponent({
  __name: 'ExportTransactionDialog',
  props: {
    isOpen: { type: Boolean },
    type: null
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit }: { emit: ({ (e: "update:isOpen", v: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean; type: "WITHDRAW" | "DEPOSIT" }




const axios = inject("$axios") as AxiosInstance;
const store = useStore();

const masks = { input: "YYYY-MM-DD" };
const maxDate = dayjs().subtract(1, "day").toDate(); // today is not exportable (matches the original dayDiff>=-1 rule)

const range = ref<{ start: Date | null; end: Date | null }>({ start: null, end: null });
const step = ref<"form" | "loading" | "done" | "error">("form");
const error = ref("");
const fileUrl = ref("");

const presets: Preset[] = [
  { key: "yesterday", label: "เมื่อวาน", build: () => { const y = dayjs().subtract(1, "day"); return { start: y, end: y }; } },
  { key: "last7", label: "7 วันล่าสุด", build: () => ({ start: dayjs().subtract(7, "day"), end: dayjs().subtract(1, "day") }) },
  { key: "thisMonth", label: "เดือนนี้", build: () => ({ start: dayjs().startOf("month"), end: dayjs().subtract(1, "day") }) },
  { key: "lastMonth", label: "เดือนก่อน", build: () => ({ start: dayjs().subtract(1, "month").startOf("month"), end: dayjs().subtract(1, "month").endOf("month") }) },
];

function applyPreset(p: Preset) {
  const r = p.build();
  range.value = { start: r.start.toDate(), end: r.end.toDate() };
}

// reset transient state each time the dialog is opened (keep last picked range)
watch(
  () => props.isOpen,
  (open) => { if (open) { step.value = "form"; error.value = ""; } }
);

function close() {
  emit("update:isOpen", false);
}
function onOverlayClose() {
  if (step.value !== "loading") close(); // do not let overlay/esc close while generating
}

function submit() {
  error.value = "";
  if (!range.value.start || !range.value.end) {
    error.value = "กรุณาเลือกวันที่";
    return;
  }
  const from = dayjs(range.value.start);
  const to = dayjs(range.value.end);
  // keep the exact rules of the original exports(): to>=from, end not within ~1 day of now, span <= 31 days
  if (to.isBefore(from)) { error.value = "กรุณากรอกใหม่"; return; }
  if (to.diff(dayjs().format(), "day", true) >= -1) { error.value = "ไม่สามารถเลือกวันที่ปัจจุบันได้"; return; }
  if (from.diff(to.format(), "day", true) < -31) { error.value = "อนุญาตให้ query ได้ไม่เกิน 31 วัน"; return; }

  step.value = "loading";
  axios
    .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/be-payment/export/transactions", {
      operatorId: store.state.selectedOperator.operatorId,
      startDate: from.format("YYYY-MM-DD"),
      endDate: to.format("YYYY-MM-DD"),
      type: props.type,
    })
    .then(({ data }) => {
      fileUrl.value = data;
      step.value = "done";
    })
    .catch((e: any) => {
      error.value = e?.response?.data?.message || "สร้างรายงานไม่สำเร็จ";
      step.value = "error";
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(DialogComponent, {
    isOpen: __props.isOpen,
    title: _ctx.$t('messages.dailyReport.exportReport'),
    "onUpdate:isOpen": onOverlayClose
  }, {
    default: _withCtx(() => [
      (step.value === 'form')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (p) => {
                return _createElementVNode("button", {
                  key: p.key,
                  type: "button",
                  onClick: ($event: any) => (applyPreset(p)),
                  class: "px-2.5 py-1 text-xs rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 focus:outline-none"
                }, _toDisplayString(p.label), 9, _hoisted_4)
              }), 64))
            ]),
            _createVNode(_component_v_date_picker, {
              modelValue: range.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
              mode: "date",
              "max-date": _unref(maxDate),
              masks: masks,
              "is-range": ""
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("input", _mergeProps({
                    class: "flex-grow px-3 py-2 bg-gray-100 border rounded w-full text-sm text-gray-900",
                    value: inputValue.start
                  }, _toHandlers(inputEvents.start), {
                    placeholder: "จากวันที่",
                    readonly: ""
                  }), null, 16, _hoisted_6),
                  _hoisted_7,
                  _createElementVNode("input", _mergeProps({
                    class: "flex-grow px-3 py-2 bg-gray-100 border rounded w-full text-sm text-gray-900",
                    value: inputValue.end
                  }, _toHandlers(inputEvents.end), {
                    placeholder: "ถึงวันที่",
                    readonly: ""
                  }), null, 16, _hoisted_8)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "max-date"]),
            _hoisted_9,
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                onClick: close,
                class: "px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
              }, " ยกเลิก "),
              _createElementVNode("button", {
                type: "button",
                onClick: submit,
                disabled: !range.value.start || !range.value.end,
                class: "inline-flex items-center px-4 py-2 text-sm rounded-md text-white bg-blue-500 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-2",
                  icon: ['far', 'file-export']
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.dailyReport.exportReport")), 1)
              ], 8, _hoisted_12)
            ])
          ]))
        : (step.value === 'loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-blue-500",
                icon: ['fas', 'circle-notch'],
                transform: "grow-8",
                spin: ""
              }),
              _hoisted_14
            ]))
          : (step.value === 'done')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-green-500",
                  icon: ['fas', 'circle-check'],
                  transform: "grow-8"
                }),
                _hoisted_16,
                _createElementVNode("a", {
                  href: fileUrl.value,
                  target: "_blank",
                  rel: "noopener",
                  onClick: close,
                  class: "inline-flex items-center px-4 py-2 rounded-md text-sm text-white bg-blue-500 hover:bg-blue-600"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "mr-2",
                    icon: ['far', 'file-export']
                  }),
                  _hoisted_18
                ], 8, _hoisted_17)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-red-500",
                  icon: ['fas', 'circle-exclamation'],
                  transform: "grow-8"
                }),
                _createElementVNode("p", _hoisted_20, _toDisplayString(error.value || "สร้างรายงานไม่สำเร็จ"), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (step.value = 'form')),
                  class: "px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
                }, " ลองใหม่ ")
              ]))
    ]),
    _: 1
  }, 8, ["isOpen", "title"]))
}
}

})